export default __webpack_public_path__ + "9612369b21d38e51e32d63fa33262a67.png";